var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center fraction"},[_c('div',{staticClass:"fraction-top",style:(this.needBottomLine ? ' border-bottom: 1px solid #78909C' : '')},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"fraction-bottom"},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }